import styled from 'styled-components'
import { tokens } from '@arvoreeducacao/bonsai-ds'

export const HierarchyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 400px;
  border-radius: 10px;
  border: 1px solid ${tokens.colors.dark2};
  overflow: hidden;
  background: ${tokens.colors.white};
`

export const HierarchyHeader = styled.div`
  padding: 16px;
  background: ${tokens.colors.white};
  box-shadow: 0px 4px 5px 0px rgba(5, 59, 75, 0.06);
  border-bottom: 1px solid ${tokens.colors.dark2};
  display: inline-flex;
  justify-content: flex-start;
  align-items: center;
  gap: 16px;

  .entity-name {
    font-size: 16px;
    font-weight: bold;
    color: ${tokens.colors.dark5};
    line-height: 1;
  }

  .entity-type {
    font-size: 12px;
    color: ${tokens.colors.dark4};
    margin-top: 4px;
  }
`

export const HierarchyContent = styled.div`
  flex: 1;
  overflow-y: auto;
  background: ${tokens.colors.white};
`

export const HierarchyList = styled.div`
  padding: 8px;
`
